import { IPaginationResponse } from '../../../common';
import {
  IWalletListResponse,
  IWalletResponse,
  IWalletTransactionResponse,
  IWalletIncomeResponse,
  IPaymentRequestChargeOrderDetailsResponse,
} from '../dtos';

const walletResponse: IWalletResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  owner: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    firstname: 'Provider One',
    lastname: 'Provider',
    userId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    email: 'provider@makani.com',
    phoneNumber: '+201118529654'
  },
  mainBalance: {
    amount: 50.37,
    currency: 'USD'
  },
  rewardsBalance: {
    amount: 50.37,
    currency: 'USD'
  },
  totalBalance: {
    amount: 50.37,
    currency: 'USD'
  },
  debtBalance: {
    amount: 0.00,
    currency: 'USD'
  },
  incomes: [
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      walletId: '550e8400-e29b-41d4-a716-446655440000',
      actual: {
        amount: 50.37,
        currency: 'USD'
      },
      remaining: {
        amount: 50.37,
        currency: 'USD'
      },
      debtPaymentAmount: {
        amount: 0,
        currency: 'USD'
      },
      expiration: '2025-09-01',
      source: 'Load',
      description: 'load wallet',
      isAvailable: true,
      isDebt: false,
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
    },
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      walletId: '550e8400-e29b-41d4-a716-446655440000',
      actual: {
        amount: 50.37,
        currency: 'USD'
      },
      remaining: {
        amount: 50.37,
        currency: 'USD'
      },
      debtPaymentAmount: {
        amount: 0,
        currency: 'USD'
      },
      expiration: '2025-09-01',
      source: 'Load',
      description: 'load wallet',
      isAvailable: true,
      isDebt: false,
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
    }
  ],
};

const walletResponses: IPaginationResponse<IWalletListResponse> = {
  items: [
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      owner: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        firstname: 'Provider One',
        lastname: 'Provider',
        userId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        email: 'provider@makani.com',
        phoneNumber: '+201118529654'
      },
      mainBalance: {
        amount: 50.37,
        currency: 'USD'
      },
      rewardsBalance: {
        amount: 50.37,
        currency: 'USD'
      },
      totalBalance: {
        amount: 50.37,
        currency: 'USD'
      },
      debtBalance: {
        amount: 0.00,
        currency: 'USD'
      }
    },
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      owner: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        firstname: 'Provider One',
        lastname: 'Provider',
        userId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        email: 'provider@makani.com',
        phoneNumber: '+201118529654'
      },
      mainBalance: {
        amount: 50.37,
        currency: 'USD'
      },
      rewardsBalance: {
        amount: 50.37,
        currency: 'USD'
      },
      totalBalance: {
        amount: 50.37,
        currency: 'USD'
      },
      debtBalance: {
        amount: 0.00,
        currency: 'USD'
      }
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 2,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const walletTransactionsResponse: IPaginationResponse<IWalletTransactionResponse> = {
  items: [
    {
      id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      walletId: '550e8400-e29b-41d4-a716-446655440000',
      orderId: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
      amount: {
        amount: 100.00,
        currency: 'USD'
      },
      reward: {
        amount: 0,
        currency: 'USD'
      },
      transactionType: 'In',
      sourceType: 'Load',
      orderNumber: 1001,
      walletOrderId: 'd4e5f6a7-b8c9-0123-def4-567890123456',
      walletOrderNumber: 5001,
      status: 'Completed',
      createdOnUtc: '2025-03-10T08:30:00Z',
      modifiedOnUtc: '2025-03-10T08:30:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    },
    {
      id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
      walletId: '550e8400-e29b-41d4-a716-446655440000',
      orderId: 'e5f6a7b8-c9d0-1234-ef56-789012345678',
      amount: {
        amount: 25.50,
        currency: 'USD'
      },
      reward: {
        amount: 0,
        currency: 'USD'
      },
      transactionType: 'Out',
      sourceType: 'Order',
      orderNumber: 1002,
      status: 'Completed',
      createdOnUtc: '2025-03-12T14:15:00Z',
      modifiedOnUtc: '2025-03-12T14:15:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const walletIncomesResponse: IPaginationResponse<IWalletIncomeResponse> = {
  items: [
    {
      id: 'b7e34f3f-2c24-491e-9b75-47b6e34f71a5',
      walletId: '550e8400-e29b-41d4-a716-446655440000',
      actual: {
        amount: 100.00,
        currency: 'USD'
      },
      remaining: {
        amount: 74.50,
        currency: 'USD'
      },
      debtPaymentAmount: {
        amount: 0,
        currency: 'USD'
      },
      expiration: '2025-09-01',
      source: 'Load',
      description: 'load wallet',
      isAvailable: true,
      isDebt: false,
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-03-12T14:15:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    }
  ],
  paginationMetadata: {
    totalItemCount: 1,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const loadWalletOnlineResponse: IPaymentRequestChargeOrderDetailsResponse = {
  chargeOrder: {
    id: 'f6a7b8c9-d0e1-2345-f678-901234567890',
    totalPrice: {
      amount: 100.00,
      currency: 'USD'
    },
    source: 'WalletLoad',
    targetId: '550e8400-e29b-41d4-a716-446655440000',
    status: 'Pending',
    client: {
      id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      englishName: 'Makani',
      arabicName: 'مكاني',
    },
    createdOnUtc: '2025-03-15T10:00:00Z',
    modifiedOnUtc: '2025-03-15T10:00:00Z',
    createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    modifiedById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  },
  paymentRequest: {
    id: 'a8b9c0d1-e2f3-4567-8901-abcdef012345',
    paymentId: 'a8b9c0d1-e2f3-4567-8901-abcdef012345',
    paymentConfigurationId: 'b9c0d1e2-f3a4-5678-9012-bcdef0123456',
    paymentProviderType: 'Telr',
    paymentRequestId: 'REQ-12345',
    paymentUrl: 'https://payment.example.com/pay/12345',
    integrity: 'abc123def456',
    createdOnUtc: '2025-03-15T10:00:00Z',
    modifiedOnUtc: '2025-03-15T10:00:00Z',
    createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    modifiedById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  }
};

export const walletsData = {
  walletResponse,
  walletResponses,
  walletTransactionsResponse,
  walletIncomesResponse,
  loadWalletOnlineResponse,
};
